import React from "react";

export default class WuformButton extends React.Component  
{
    reviewForm = () =>
    {
        if (typeof window !== "undefined") window.open('https://hometown.wufoo.com/forms/get-started/',  null, 'height=600, width=680, toolbar=0, location=0, status=1, scrollbars=1, resizable=1'); 
        
        return false
    }
   
    render()
    {       
        return (
            <div className="block services successtories mb-5">               
                <div className="card"> 
                    <h3>Get New Customer Leads</h3> 
                    <p>If your company provides great service, Hometown can generate new customers for you. Call us at (877) 994-6645 or get started below.</p>
                    <a className="btn btn-primary" href="#" onClick={this.reviewForm}>Pros Get Started</a>                     
                </div>
            </div>
        )
    }
};